/* eslint-disable implicit-arrow-linebreak */
import { ThunkAction } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { Action, combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import authReducer from './slices/auth';
import alertReducer from './slices/alert';
import modalReducer from './slices/modal';
import cartReducer from './slices/cart';
import orderReducer from './slices/order';
import printerReducer from './slices/printer';
import deliveryReducer from './slices/delivery';

const rootReducer = combineReducers({
  auth: authReducer,
  alert: alertReducer,
  modal: modalReducer,
  cart: cartReducer,
  order: orderReducer,
  printer: printerReducer,
  delivery: deliveryReducer
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof rootReducer>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppThunk = ThunkAction<void, RootState, undefined, Action<string>>;

const persistConfig = {
  key: 'oyasync',
  storage,
  blacklist: ['alert', 'modal', 'delivery'], // State that will not be persisted
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export default persistedReducer;
